import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from 'react-router-dom';
import {
      Box,
      IconButton,
      Typography
} from "@mui/material";
import React, { useState } from 'react';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import { getFacilityId, getcompanyId } from '../../utility/tokenUtility';
import AssetServiceChangeList from "./AssetServiceChangeList";
import PageTitle from "../commoncomponents/PageTitle";
function AssetServiceChangeMain() {
      const facilityId = getFacilityId();
      const companyId = getcompanyId();
      const navigate = useNavigate();
      const handleHomeClick = () => {
        navigate('/dashboard'); // Adjust the path as needed
      };

      return (
            <>
                  <BreadcrumbBar>
                        <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>
                        {/* <IconButton aria-label="home" disableRipple onClick={handleHomeClick}>
                                    <HomeIcon />
                              </IconButton>
                              <Typography sx={{   fontWeight: 'bold',fontSize: '1.5rem',px: 2, borderLeft: { sm: "1px solid #D8D8D8" } }}>
                               Asset Service Change
                              </Typography> */}
                              <PageTitle title={"Asset Service Change"} />
                        </Box>
          
                  </BreadcrumbBar>
                  <AssetServiceChangeList facilityId={facilityId} companyId={companyId}/>
            </>
      );
}

export default AssetServiceChangeMain;
